import { render, staticRenderFns } from "./BaseCounter.vue?vue&type=template&id=0d6d302a&scoped=true&"
import script from "./BaseCounter.vue?vue&type=script&lang=ts&"
export * from "./BaseCounter.vue?vue&type=script&lang=ts&"
import style0 from "./BaseCounter.vue?vue&type=style&index=0&id=0d6d302a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6d302a",
  null
  
)

export default component.exports